
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const DetailsContent = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Allgemeine Hinweise und Pflichtinformationen</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4 text-sm text-joerg-600">
        <div>
          <h4 className="font-medium text-joerg-700 mb-2">Datenschutz</h4>
          <p className="leading-relaxed">
            Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
            Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden können. Die vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir sie nutzen. Sie erläutert auch, wie und zu welchem Zweck das geschieht.
            Wir weisen darauf hin, dass die Datenübertragung im Internet (z.&nbsp;B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.
          </p>
        </div>
        
        <div>
          <h4 className="font-medium text-joerg-700 mb-2">Geltungsbereich</h4>
          <p className="leading-relaxed">
            Diese Datenschutzerklärung gilt für das Internetangebot unter der Domain <strong>joerg-hoermann.de</strong> sowie alle zugehörigen Subdomains, insbesondere:
          </p>
          <ul className="list-disc list-inside mt-2 space-y-1 ml-4">
            <li>hochsensible-fuehrung.joerg-hoermann.de</li>
            <li>reflexionen-zen.joerg-hoermann.de</li>
            <li>sowie alle weiteren zukünftigen Subdomains unter joerg-hoermann.de</li>
          </ul>
        </div>
        
        <div>
          <h4 className="font-medium text-joerg-700 mb-2">Hinweis zur verantwortlichen Stelle</h4>
          <p className="leading-relaxed">
            Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website und allen zugehörigen Subdomains ist:<br /><br />
            Jörg Hörmann Coaching & Consulting<br />
            Grimmstr. 15<br />
            91154 Roth<br /><br />
            Telefon: 09171-9892118<br />
            E-Mail: info@joerg-hoermann.de<br /><br />
            Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z.&nbsp;B. Namen, E-Mail-Adressen o.&nbsp;Ä.) entscheidet.
          </p>
        </div>
        
        <div>
          <h4 className="font-medium text-joerg-700 mb-2">Widerruf Ihrer Einwilligung zur Datenverarbeitung</h4>
          <p className="leading-relaxed">
            Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an info@joerg-hoermann.de. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
          </p>
        </div>
        
        <div>
          <h4 className="font-medium text-joerg-700 mb-2">Beschwerderecht bei der zuständigen Aufsichtsbehörde</h4>
          <p className="leading-relaxed">
            Im Falle datenschutzrechtlicher Verstöße steht dem Betroffenen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu. Zuständige Aufsichtsbehörde in datenschutzrechtlichen Fragen ist das Bayerische Landesamt für Datenschutzaufsicht (BayLDA), Promenade 18, 91522 Ansbach. Weitere Informationen: <a href="https://www.lda.bayern.de" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">www.lda.bayern.de</a>
          </p>
        </div>
        
        <div>
          <h4 className="font-medium text-joerg-700 mb-2">Recht auf Datenübertragbarkeit</h4>
          <p className="leading-relaxed">
            Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags automatisiert verarbeiten, an sich oder an einen Dritten in einem gängigen, maschinenlesbaren Format aushändigen zu lassen. Sofern Sie die direkte Übertragung der Daten an einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch machbar ist.
          </p>
        </div>
        
        <div>
          <h4 className="font-medium text-joerg-700 mb-2">SSL- bzw. TLS-Verschlüsselung</h4>
          <p className="leading-relaxed">
            Alle Seiten unter joerg-hoermann.de und den zugehörigen Subdomains nutzen aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von „http://" auf „https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
            Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns übermitteln, nicht von Dritten mitgelesen werden.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default DetailsContent;
